import { useState } from "react";
import "../assets/css/signUp.css";
import { useNavigate } from "react-router-dom";
import { BOUsersController } from "../controllers/boUsersController";
import { validateSignUpForm } from "../validations/signUpForm";
import { Textbox } from "../components/textbox";
import { useToastPromise } from "../components/toastPromise";

export const SignUp = () => {
  const toastPromise = useToastPromise();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateSignUpForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    toastPromise({
      promise: new Promise((resolve, reject) => {
        BOUsersController.signUp({
          parameters: inputs,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => `Redirecting to login page.`,
      errorMessage: (data) => data,
      finishPromise: () => navigate("/login"),
    });
  };

  //   const updateUser = async (id, password) => {
  //     const userDoc = doc(db, "users", id);
  //     const newFields = { password: password };
  //     await updateDoc(userDoc, newFields);
  //     getUsers();
  //   };

  //   const deleteUser = async (id) => {
  //     const userDoc = doc(db, "users", id);
  //     await deleteDoc(userDoc);
  //     getUsers();
  //   };

  return (
    <section id="signUP">
      <div className="sign-up-container">
        <h3>SIGN UP</h3>
        <hr />
        <form onSubmit={handleSubmit}>
          <Textbox
            type="text"
            name="firstName"
            placeholder="First Name"
            value={inputs.firstName}
            onChange={handleChange}
            errorMsg={errors.firstName}
          />
          <Textbox
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={inputs.lastName}
            onChange={handleChange}
            errorMsg={errors.lastName}
          />
          <Textbox
            type="text"
            name="email"
            placeholder="Email Address"
            value={inputs.email}
            onChange={handleChange}
            errorMsg={errors.email}
          />
          <Textbox
            type="password"
            name="password"
            placeholder="Password"
            value={inputs.password}
            onChange={handleChange}
            errorMsg={errors.password}
          />
          <Textbox
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={inputs.confirmPassword}
            onChange={handleChange}
            errorMsg={errors.confirmPassword}
          />
          <input type="submit" value="Sign Up" />
        </form>
      </div>
    </section>
  );
};
